// const apsProductionEnv = 'https://apsadmin.li-gong.com';
const apsTestEnv = 'https://apsadmin.li-gong.com';
// const apsDevelopmentEnv = 'http://192.168.0.138:9999';
const apsDevelopmentEnv = 'http://10.0.30.245:9999';

export const baseUrls = {
    aps1: process.env.NODE_ENV === 'production' ? `${apsTestEnv}/order` : `${apsDevelopmentEnv}/order`,
    aps2: process.env.NODE_ENV === 'production' ? `${apsTestEnv}` : `${apsDevelopmentEnv}`,
};